import { Bold } from "capitalrx-components-2.0/lib/typography";
import { Body } from "capitalrx-components-2.0/lib/typography";
import { convertCapsToPascal } from "../../utilities";

import { PharmacyDetails } from "./types";

export const getAddress = (data: PharmacyDetails): Array<string> => {
  const addressLineOne = convertCapsToPascal(data.address_line_1);
  const addressLineTwo = convertCapsToPascal(String(data.address_line_2));
  const city = convertCapsToPascal(data.city);
  const zip = data.zip.slice(0, 5);

  let pharmacyAddressLineTwo = addressLineTwo;
  if (addressLineTwo.length) {
    pharmacyAddressLineTwo = `${addressLineTwo},`;
  }
  if (city) {
    pharmacyAddressLineTwo = `${pharmacyAddressLineTwo} ${city}`;
  }
  if (data.state) {
    pharmacyAddressLineTwo = `${pharmacyAddressLineTwo}, ${data.state}`;
  }
  if (zip) {
    pharmacyAddressLineTwo = `${pharmacyAddressLineTwo}, ${zip}`;
  }

  return [addressLineOne, pharmacyAddressLineTwo];
};

export const getSubHeading = (data: PharmacyDetails, distance: string | number): string => {
  const [addressLineOne] = getAddress(data);
  let pharmacyItemSubHeader = `${distance} miles | ${addressLineOne}`;

  if (!distance) {
    pharmacyItemSubHeader = addressLineOne;
  }

  return pharmacyItemSubHeader;
};

interface PharmacyMapCalloutProps {
  data: PharmacyDetails;
  distance: string | number;
  id: string;
}

export const PharmacyMapCallout = ({ data, distance, id }: PharmacyMapCalloutProps): JSX.Element => {
  const [_, addressLineTwo] = getAddress(data);
  if (typeof distance === "string") {
    distance = parseFloat(distance);
  }
  return (
    <div id={id}>
      <Body className="Name">
        <Bold>{data.name}</Bold>
      </Body>
      <Body>{getSubHeading(data, distance.toFixed(2))}</Body>
      <Body>{addressLineTwo}</Body>
    </div>
  );
};
